var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-card',_vm._g(_vm._b({staticClass:"sh-card",attrs:{"body-style":_vm.bodyStyle,"shadow":_vm.shadow}},'el-card',_vm.$attrs,false),_vm.$listeners),[_vm._l((_vm.$slots),function(_,name){return _vm._t(name)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }